module.exports = __webpack_public_path__ + "img/jiejue2.691d451a.png";